import { fmtChips } from "../helpers";

export function HuntersView({ hunters }) {
  if (!hunters?.length) return null;
  return (
    <section className="border-t border-white/10 px-3 py-3 bg-rose-900/10" data-testid="hunters-view">
      <h4 className="text-[11px] uppercase tracking-wider font-semibold text-rose-300 mb-2">
        KO Hunters ({hunters.length})
      </h4>
      <table className="w-full text-[12px] text-slate-300">
        <thead className="text-slate-500">
          <tr><th className="text-left">Jugador</th><th className="text-right">KOs</th><th className="text-right">Reward</th><th className="text-right">Bonus</th></tr>
        </thead>
        <tbody>
          {hunters.map((h, i) => (
            <tr key={i}>
              <td className="truncate">{h.nick || `uid:${h.uid}`}</td>
              <td className="text-right tabular-nums">{h.ko_cnt}</td>
              <td className="text-right tabular-nums">{fmtChips(h.hunter_reward_chips)}</td>
              <td className="text-right tabular-nums">{fmtChips(h.hunter_bonus_chips)}</td>
            </tr>
          ))}
        </tbody>
      </table>
    </section>
  );
}
